"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RegistrationErrorCodes;
(function (RegistrationErrorCodes) {
    RegistrationErrorCodes["commonConstraintViolation"] = "COMMON__CONSTRAINT_VIOLATION";
    RegistrationErrorCodes["duplicatesDetected"] = "ACCOUNT__DUPLICATES_DETECTED";
})(RegistrationErrorCodes || (RegistrationErrorCodes = {}));
exports.default = RegistrationErrorCodes;
